<template>
  <div>
    <h1>{{ this.translate[object] }}</h1>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + 'No *'"
      :label-for="object + '_no'"
      label-align="left"
      required>
      <b-form-input
        :id="object+'_no'"
        v-model="payloads.no"
        :disabled="!isNew || this.object === 'system_specification'"
        :state="noValidator"
      ></b-form-input>
      <b-form-invalid-feedback
        :id="object+'_no'"
        class="text-left">
        正の整数を入力してください
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '改定記号'"
      :label-for="object + '_revision_symbol'"
      label-align="left">
      <b-form-input :id="object+'_revision_symbol'" v-model="payloads.revision_symbol"></b-form-input>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '名称 *'"
      :label-for="object + '_name'"
      label-align="left">
      <b-form-input :id="object+'_name'" v-model="payloads.name"  :state="nameValidator"></b-form-input>
      <b-form-invalid-feedback :id="object+'_name'" class="text-left">
        名前を入力してください
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '説明'"
      :label-for="object + '_description'"
      label-align="left">
      <b-form-textarea :id="object+'_description'" rows=5 v-model="payloads.description"></b-form-textarea>
    </b-form-group>
    <b-form-group
      label-cols="3"
      :label="this.translate[object] + '制約'"
      :label-for="object + 'restrictions'"
      label-align="left">
      <b-form-textarea :id="object+'restrictions'" rows=5 v-model="payloads.restrictions"></b-form-textarea>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'BasicObject',
  props: ['object', 'isNew', 'payloads'],
  computed: {
    noValidator () {
      return Number.isInteger(parseInt(this.payloads.no)) && parseInt(this.payloads.no) > 0
    },
    nameValidator () {
      return this.payloads.name !== '' && this.payloads.name !== null
    }
  }
}
</script>
